import React, { Component } from 'react';
import LiveNFT from './LiveNFT.js'
import instagramIcon from './InstagramIcon.png';
import spotifyIcon from './SpotifyIcon.png';
import twitterIcon from './TwitterIcon.png';
import discordIcon from './DiscordIcon.png';
import githubIcon from './GithubIcon.png';
import youtubeIcon from './YoutubeIcon.png';

class StreamerProfileSocials extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }


  render() {
    return (
        <div className="flex ml-12">
          {
            this.props.socials != null
              ?
            <div className="flex">
              {
                this.props.socials.spotify != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.spotify, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[24px] mt-2" src={spotifyIcon}
                />
                  :
                null
              }
              {
                this.props.socials.instagram != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.instagram, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[24px] mt-2 ml-2" src={instagramIcon}
                />
                  :
                null
              }
              {
                this.props.socials.twitter != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.twitter, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[24px] mt-2 ml-2" src={twitterIcon}
                />
                  :
                null
              }
              {
                this.props.socials.discord != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.discord, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[26px] mt-2 ml-2" src={discordIcon}
                />
                  :
                null
              }
              {
                this.props.socials.github != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.github, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[24px] mt-2 ml-2 rounded-full" src={githubIcon}
                />
                  :
                null
              }
              {
                this.props.socials.youtube != null
                  ?
                <img
                  onClick={()=> window.open(this.props.socials.youtube, "_blank")}
                  className="cursor-pointer hover:-translate-y-0 hover:scale-110 duration-500 h-[26px] mt-2 ml-2 rounded-full" src={youtubeIcon}
                />
                  :
                null
              }
            </div>
              :
            null
          }
        </div>
    );
  }
}

export default StreamerProfileSocials;
